<div class="rk-ui-notification err" *ngIf="erroralert"  style="z-index: 10000;">
	<span id="notificationMessageText">{{errorMessage}}</span>
	<a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="rk-ui-notification" *ngIf="successalert"  style="z-index: 10000;">
	<span id="notificationMessageText">{{successMessage}}</span>
	<a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="row  pr-3 mt-2 justify-content-center">
	<div class="col-md-8">
		<div class="row">
			<div class="col-md-6">
				<label class="select select-label">
							<select class="bg-white pl-4 cursor-pointer" (change)="selectBoq($event)">
                <option value="" selected>Select Quotation</option>
							  <option  *ngFor="let boq of boq_list"  value="{{ boq.id }}" >{{ boq.reference_number }}</option>
							</select>
				</label>
				
			</div>
			<div class="col-md-6" *ngIf="selected_boq">
				<div class="dropdown">
					  <button class="btn btn-split dropdown-toggle pull-right text-capitalize" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					    {{ split_name | replaceChar }}
					  </button>
					  <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
					    <ng-container *ngFor="let split of split_type">
					    	<button class="dropdown-item text-capitalize" type="button" (click)="selectSplitType(split.id,split.name)">{{ split.name | replaceChar}}</button>
					    </ng-container>	

					  </div>
				</div>
				
			</div>
			
		</div>
		<div class="row mt-2">
			<div class="col-md-12">
				<div class="table-responsive">

          <table class="table parent-table">
            <thead class="thead-dark">
              <tr>
                <!-- <th class="firstTh"></th> -->
                <th class="firstTh text-center">Section</th>
                <th style="width: 19%;text-align:center;">Line Item</th>
                <th class="text-center">production Drawings</th>
                <th class="lastTh w-25 text-center">Split</th>
              </tr>
            </thead>
            <tbody *ngIf="line_item_Arr.length > 0">

              <ng-container >
              	<tr class="addCursor "  *ngFor="let obj of line_item_Arr;let i = index">
	              	<!-- <td class="md-empty"></td> -->
	              	<td class="md-cell d-flax">
	              		<div class="form-group form-check d-flax">
									    <input type="checkbox" class="form-check-input" id="parent-{{ obj }}" name="selectAll"  (change)="toggleAll(obj,$event)">
									     <label class="form-check-label d-flax" for="exampleCheck1">{{ obj | replaceChar  }}
									     
									     </label>
									     
									     
									  </div>
									  <i class="fa  fa-angle-up angle-chng ml-4 mt-4 pt-3" style="font-size:24px; " (click)="toggleRow(obj)" *ngIf="rowSelected ==  obj"></i>
									  
									  <i class="fa  fa-angle-down angle-chng ml-4 mt-4 pt-3" style="font-size:24px; " (click)="toggleRow(obj)" *ngIf="rowSelected !=  obj"></i>
	              	</td>
	              	<td colspan="4" class="p-0" *ngIf="rowSelected ==  obj">
	              		<table class="table small-table mb-0">
										  <tbody>
										    <tr *ngFor="let item of split_line_item_list[obj];let k = index">
										      <td style="width:29%">
										      	<div class="form-group form-check d-flex" >
													    <input type="checkbox" class="form-check-input-chng" id="exampleCheck2"  [checked]="item.checked" (change)="toggleItem(item,$event,obj)">
													     <label class="form-check-label-child pop cursor-pointer txetcondtiotn" for="exampleCheck2" (mouseenter)="openpopup($event)" style="color: black;" title="{{ item.name }}">{{ item.name}}

													     </label>
													<!-- <p for="exampleCheck2" (mouseenter)="openpopup($event)" style="color: black;" title="{{ item.name }}">{{ item.name }}</p> -->
												
													  </div>
													  <p><b>QTY:{{item.quantity}}</b></p>
										      </td>
										      <td class="w-50">
										      	<ng-container *ngFor="let drawings of item.production_drawings;let j = index">
										      		<span class="text-muted text-tiny" *ngIf="drawings.attributes.file_details == 'No production'">
										      			No Production Drawing Needed
                                                    </span>
										      		<span class="text-muted text-tiny" *ngIf="drawings.attributes.file_details != 'No production'"><i class="fa fa-times text-danger mx-1" (click)="removeDrawings(obj,j,drawings.attributes.id,k)" style="font-weight: 600"></i><!-- {{ drawings.attributes.file_details.name }}, -->
 
										      		<a href="{{drawings.attributes.file_details.file_url}}" download target="_blank">{{drawings.attributes.file_details.name}}</a>, </span><span class="text-muted text-tiny" *ngIf="drawings.attributes.file_details != 'No production'">{{ drawings.attributes.created_at |  date:'dd/MM/yyyy-h:mm a'}}</span><br>
 
										      	</ng-container>	

										      </td>
										      <td class="w-50" >
										      	<ng-container *ngIf="item.split">
										          {{ item.split.name | replaceChar }}
										          <span style="font-size:10px;font-weight: 500">{{item.split.created_at | date:'dd/MM/yyyy - h:mm a'}}</span>
										        </ng-container>  
										      </td>
										    </tr>
										    
										  </tbody>
										</table>
	              	</td>
	              	<td colspan="4" class="md-cell p-0" *ngIf="!obj.expanded">
	              		
	              	</td>
	                     
	              </tr>
              </ng-container>	
              
            </tbody>

          </table>

         </div>
				
			</div>
			<div class=" col-12 pb-3 px-5 bg-white" *ngIf="line_item_Arr && line_item_Arr.length == 0" style="border: 9px solid #ECF0F1;">
            <div class="boq-img text-center">
              <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
            </div>
            <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">No BOQ Selected...</p>

      </div>
			
		</div>
		
	</div>
	<div class="col-md-4 mb-2">
		<app-assign-files-category [project_id]='project_id_split'  (sendAssignedFiles)="customFunc($event)" ></app-assign-files-category>

	</div>	
</div>




// WEBPACK FOOTER //
// ./src/app/platform/category/category/split/split.component.html